"use client";
import { useState, useCallback } from "react";

type storageTypes = "sessionStorage" | "localStorage";

export const LOCAL_STORAGE = "localStorage";
export const SESSION_STORAGE = "sessionStorage";

const useWindowStorage = <T = any>(
  keyName: string,
  defaultValue: T,
  storageType: storageTypes = LOCAL_STORAGE,
) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window[storageType].getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else if (defaultValue !== undefined) {
        window[storageType].setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (newValue: T) => {
      try {
        window[storageType].setItem(keyName, JSON.stringify(newValue));
      } catch (err) {}
      setStoredValue(newValue);
    },
    [keyName, storageType],
  );

  const deleteItem = useCallback(() => {
    try {
      window[storageType].removeItem(keyName);
    } catch (err) {}
    setStoredValue(undefined);
  }, [keyName, storageType]);

  return [storedValue, setValue, deleteItem] as [T, typeof setValue, typeof deleteItem];
};

export default useWindowStorage;
